import { ReactNode, useState } from "react";
interface ITooltipProps {
    children: ReactNode
    content: string
}
const Tooltip: React.FC<ITooltipProps> = ({ children, content }) => {
    const [isVisible, setIsVisible] = useState(false);
    return (
        <div
            className="relative flex"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 w-max bg-gray-800 text-white text-sm rounded-md px-3 py-2 shadow-lg z-10 border border-gray-800">
                    {content}
                    <div className="absolute top-1/2 transform -translate-y-1/2 -right-4 border-8 border-transparent border-l-gray-800"></div>
                </div>
            )}
        </div>
    )
}
export default Tooltip;